import {
  NotifyConfig,
  NotifyOptions,
  NotifyQuery,
  SocketInstance,
} from "./interface";
import { webSocketInit } from "./socket";

class Notify {
  public socket: SocketInstance;

  private opts: NotifyOptions;

  private query: NotifyQuery;

  // eslint-disable-next-line no-useless-constructor
  constructor(private config: NotifyConfig) {}

  public init(query: NotifyQuery, opts: NotifyOptions): Notify {
    this.opts = opts;
    this.query = query;
    return this;
  }

  private connectWithV2(): SocketInstance {
    let socket: SocketInstance = {
      socket: null,
    };
    if (window.WebSocket) {
      socket = webSocketInit(
        {
          ...this.config,
          query: {
            userId: this.query.userId,
            hotelId: this.query.merchantId,
          },
        },
        this.opts
      );
    } else {
      this.opts.error(
        new Error(
          "该浏览器不支持webSocket，请切换至高版本的chrome，便于实时查看订单通知"
        )
      );
    }
    return socket;
  }

  public start(): Notify {
    // 清空socket
    this.socket = {
      socket: null,
    };
    let socket = {
      socket: null,
    };
    // 先把所有订单置成0，防止切换酒店后提示错误
    this.opts.update({
      count: null,
      hasNewOrder: false,
    });
    socket = this.connectWithV2();
    this.socket = socket;
    return this;
  }

  public stop(): void {
    if (this.socket && this.socket.socket) {
      this.socket.close(this.socket.socket);
    }
  }
}

export default Notify;
